import {ApexOptions} from 'apexcharts'
import {useEffect, useState} from 'react'
import Chart from 'react-apexcharts'
export const ChartObservations = ({
  chartDataObservations,
}: {
  chartDataObservations: ApexOptions
}) => {
  const [chartImage, setChartImage] = useState<string>('')
  const handleGenerateImageChart = async (id: string) => {
    const chartInstance = window.Apex._chartInstances.find((chart: any) => chart.id === id)
    if (chartInstance) {
      const base64Image = await chartInstance.chart.dataURI()
      const {imgURI} = base64Image
      setChartImage(imgURI)
    }
  }
  useEffect(() => {
    handleGenerateImageChart('observations')
  }, [chartDataObservations])

  return (
    <>
      <div className='d-block'>
        <Chart
          options={chartDataObservations}
          series={chartDataObservations.series}
          height={350}
          type='bar'
        />
      </div>
      {/* <div className='d-none charts-print'>
        <img src={chartImage} className='w-100 h-auto' alt='' />
      </div> */}
    </>
  )
}
